// @flow

export const OBJECT_TYPE_FORM_FIELDS = ['date', 'carconfiguration'];

export default null;
